/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentRoundRobinStanding
 */
export interface TournamentRoundRobinStanding {
    /**
     * 
     * @type {number}
     * @memberof TournamentRoundRobinStanding
     */
    rank?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentRoundRobinStanding
     */
    teamId?: string;
    /**
     * Team display name
     * @type {string}
     * @memberof TournamentRoundRobinStanding
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentRoundRobinStanding
     */
    played?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentRoundRobinStanding
     */
    wins?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentRoundRobinStanding
     */
    losses?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentRoundRobinStanding
     */
    points?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentRoundRobinStanding
     */
    pointsFor?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentRoundRobinStanding
     */
    pointsAgainst?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentRoundRobinStanding
     */
    pointDifferential?: number;
}

/**
 * Check if a given object implements the TournamentRoundRobinStanding interface.
 */
export function instanceOfTournamentRoundRobinStanding(value: object): value is TournamentRoundRobinStanding {
    return true;
}

export function TournamentRoundRobinStandingFromJSON(json: any): TournamentRoundRobinStanding {
    return TournamentRoundRobinStandingFromJSONTyped(json, false);
}

export function TournamentRoundRobinStandingFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentRoundRobinStanding {
    if (json == null) {
        return json;
    }
    return {
        
        'rank': json['rank'] == null ? undefined : json['rank'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'name': json['name'] == null ? undefined : json['name'],
        'played': json['played'] == null ? undefined : json['played'],
        'wins': json['wins'] == null ? undefined : json['wins'],
        'losses': json['losses'] == null ? undefined : json['losses'],
        'points': json['points'] == null ? undefined : json['points'],
        'pointsFor': json['pointsFor'] == null ? undefined : json['pointsFor'],
        'pointsAgainst': json['pointsAgainst'] == null ? undefined : json['pointsAgainst'],
        'pointDifferential': json['pointDifferential'] == null ? undefined : json['pointDifferential'],
    };
}

export function TournamentRoundRobinStandingToJSON(json: any): TournamentRoundRobinStanding {
    return TournamentRoundRobinStandingToJSONTyped(json, false);
}

export function TournamentRoundRobinStandingToJSONTyped(value?: TournamentRoundRobinStanding | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rank': value['rank'],
        'teamId': value['teamId'],
        'name': value['name'],
        'played': value['played'],
        'wins': value['wins'],
        'losses': value['losses'],
        'points': value['points'],
        'pointsFor': value['pointsFor'],
        'pointsAgainst': value['pointsAgainst'],
        'pointDifferential': value['pointDifferential'],
    };
}

